import { observer } from 'mobx-react-lite';

import { useStoreContext } from 'store/app';
import { QuestCard } from './components/questCard';
import { Modal, ModalProps } from '../modal';
import { useTranslationsContext } from 'store/translations';
import { useEffect, useState } from 'react';

import './questsModal.styl';
import { QuestInfoModal } from '../questInfoModal';
import { ITaskConfig } from 'src/types';

interface QuestsModalProps extends ModalProps {}

export const QuestsModal = observer(({ preopenId, onPreopenOpened, ...rest }: QuestsModalProps) => {
    const { questsConfig, saveQuestsSnapshot, hasNewQuests, userVariables, logOperation, isShowResults } =
        useStoreContext();
    const { translate } = useTranslationsContext();
    const [selectedQuest, setSelectedQuest] = useState<ITaskConfig>();

    const filtredQuests = (questsConfig?.tasks || []).filter((quest) => !quest.done);

    useEffect(() => {
        logOperation('tasks', 'render');

        if (hasNewQuests() || !userVariables?.quests_snapshot) {
            saveQuestsSnapshot();
        }

        if (preopenId) {
            const preopenQuest = questsConfig?.tasks?.find((x) => x.key === preopenId);
            if (preopenQuest) {
                setSelectedQuest(preopenQuest);
            }

            onPreopenOpened?.();
        }
    }, []);

    return (
        <Modal title={translate('title.quests')} className={'quests-modal-wrapper'} {...rest}>
            <div className="quests-modal">
                {!isShowResults ? (
                    filtredQuests.map((task) => {
                        return <QuestCard mission={task} key={task.key} />;
                    })
                ) : (
                    <div className="quests-modal-end-text">
                        {translate(
                            'quests.end.text',
                            {},
                            'Игра завершена. Больше заданий нет. Надеемся, мы порадовали Вас гарантированными призами за их выполнение.'
                        )}
                    </div>
                )}
            </div>
            {selectedQuest && (
                <QuestInfoModal
                    isOpened={!!selectedQuest}
                    mission={selectedQuest}
                    onClose={() => {
                        setSelectedQuest(undefined);
                    }}
                />
            )}
        </Modal>
    );
});
